/**
 * Hello World example component
 */
const FingerPrint2 = require('fingerprintjs2');

module.exports = function (app) {
  app.registerComponent('vote', '.js-vote', function (sb, el) {

  var onClick = function (ev) {
    var url = el.getAttribute('href')


    // add fingerprint token to the url
    var token =  app.session.fingerPrint;
    url = url + '&token='+token;
    // add fingerprint
    // when no fingerprint, try to get the fingerprint
    // [implement]
    // if (!app.session.fingerPrint) {

    // }
    //sb.publish('header-body/load', url)
    //console.log( app.session.fingerPrint)

    sb.publish('overlay/show', {'contentUrl':url})


    ev.preventDefault()
    ev.stopPropagation()
  }

    /* INIT ------------------------------------------- */
    return {
      init: function () {
      el.addEventListener('click', onClick)
      },
      destroy: function () {
      }
    }
  })
}



// WEBPACK FOOTER //
// ./assets/js/components/vote.js